var _path, _path2, _path3, _path4, _path5, _path6;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgDollar(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M257 0C116.302 0 0 114.3 0 255s116.302 257 257 257 255-116.3 255-257S397.698 0 257 0z",
    fill: "#fedb41"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M512 255c0 140.7-114.302 257-255 257V0c140.698 0 255 114.3 255 255z",
    fill: "#fc3"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M257 60C149.598 60 60 147.599 60 255s89.598 197 197 197 195-89.599 195-197S364.402 60 257 60z",
    fill: "#fea832"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M452 255c0 107.401-87.598 197-195 197V60c107.402 0 195 87.599 195 195z",
    fill: "#fe9923"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M287 240h-15v-60h15c8.401 0 15 6.599 15 15 0 19.799 30 19.799 30 0 0-24.901-20.098-45-45-45h-15v-15c0-9.901-7.5-15-15-15s-15 5.099-15 15v15h-17c-24.902 0-45 20.099-45 45v30c0 24.901 20.098 45 45 45h17v62h-17c-8.401 0-15-6.599-15-15 0-19.799-30-19.799-30 0 0 24.901 20.098 45 45 45h17v15c0 9.901 7.5 15 15 15s15-5.099 15-15v-15h15c24.902 0 45-20.099 45-45v-32c0-24.901-20.098-45-45-45zm-45 0h-17c-8.401 0-15-6.599-15-15v-30c0-8.401 6.599-15 15-15h17v60zm60 77c0 8.401-6.599 15-15 15h-15v-62h15c8.401 0 15 6.599 15 15v32z",
    fill: "#fedb41"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M287 240h-15v-60h15c8.401 0 15 6.599 15 15 0 19.799 30 19.799 30 0 0-24.901-20.098-45-45-45h-15v-15c0-9.901-7.5-15-15-15v272c7.5 0 15-5.099 15-15v-15h15c24.902 0 45-20.099 45-45v-32c0-24.901-20.098-45-45-45zm15 77c0 8.401-6.599 15-15 15h-15v-62h15c8.401 0 15 6.599 15 15v32z",
    fill: "#fc3"
  })));
}

export default __webpack_public_path__ + "ce6ea040341746383b46d1ce8789f329.svg";
export { SvgDollar as ReactComponent };